module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/logo/affirm-icon-bw-logo-1cd7ee3ee4f4ee10a33657dfd1849780.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/logo/affirm-icon-bw-logo.svg
// module id = vGQ9
// module chunks = 24